import React, { Component } from "react";
import Share from "./Share";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{ paddingBottom: 32 }}>
        <div style={{ fontSize: "90%", fontStyle: "italic" }}>
          Was this documentation helpful and up-to-date? If not please let us
          know {" "}
          <a
            href={
              "https://www.nexoid.com/contact_us?mode=developer_feedback" +
              (this.props.section !== undefined
                ? "/" + this.props.section
                : "") +
              (this.props.article !== undefined ? "/" + this.props.article : "")
            }
            target="_blank"
          >
            development feedback
          </a>
          . At Nexoid quality is everything to us and your feedback is important
          to us.
        </div>
        {this.props.routeParams.article !== undefined ? (
          <div>
            <Share section={this.props.section} article={this.props.article} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js